import crudlModuleGenerator from '@/_CRUDL/modules/generator';

export default crudlModuleGenerator('upfrontFeeRules', {
  customKeys: {
    list: 'upfront_fee_rules',
  },
  customEndpoints: {
    delete: '/upfront_fee_rules/:id/deactivate',
  },
  customMethods: {
    delete: 'get',
  },
});
